import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';

import { WorkspaceType } from 'Shared/constants/types';

import FormRecurringMeeting from './FormRecurringMeeting';
import FormMobileRecurringMeeting from './FormMobileRecurringMeeting';
import FormSelectAll from '../FormSelectAll';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './index.scss';

type Props = {
  type: WorkspaceType;
  selector: string;
  label?: string;
  mobileVersion?: boolean;
};

function RecurringMeetingsSelection({ selector, type, label, mobileVersion = false }: Props) {
  const { user, id: currentUserId } = useCurrentUser();
  const currentUserEmail = user.email;
  const { tr } = useTranslation();

  const isGroupType = type === WorkspaceType.isGroup;

  return (
    <div className="RecurringMeetingsSelection">
      <div className="d-flex justify-content-between mb-2">
        {label && <div className="RecurringMeetingsSelection__label">{label}</div>}
        <Field name={selector} component={FormSelectAll} />
      </div>
      <FieldArray name={selector}>
        {({ fields }) =>
          fields.length ? (
            fields.map((name, index) => (
              <Field
                key={fields.value[index].id || fields.value[index].uuid}
                index={index}
                name={name}
                isGroupType={isGroupType}
                currentUserEmail={currentUserEmail}
                currentUserId={currentUserId}
                component={mobileVersion ? FormMobileRecurringMeeting : FormRecurringMeeting}
              />
            ))
          ) : (
            <div className="RecurringMeetingsSelection__empty-area p-3 text-center">
              {tr('perform.workspace.recurring_meetings.empty')}
            </div>
          )
        }
      </FieldArray>
    </div>
  );
}

export default RecurringMeetingsSelection;
